import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCode,
  faRemove,
  faSearch,
  faFlaskVial,
  faPrescriptionBottle,
  faCircleInfo,
  faTablets,
  faWineBottle,
  faCubesStacked,
  faGear,
  faSitemap,
  faAngleDown,
  faAngleUp,
  faAnglesDown,
  faAnglesUp,
  faCalendarCheck,
  faCalendar,
  faUserGear,
  faUser,
  faBars,
  faXmark,
  faArrowLeft,
  faBook,
  faPrint,
  faTentArrowDownToLine,
  faCalendarDay,
  faEyeDropper,
  faTimeline,
  faPen,
  faFileExcel,
  faFileArrowDown,
  faBreadSlice,
  faBox,
  faPlus,
  faCircle,
  faFilter,
  faFilterCircleXmark,
  faDroplet,
  faAnglesRight,
  faCalendarPlus,
  faLink,
  faSort,
  faSortUp,
  faSortDown,
  faGroupArrowsRotate,
  faQrcode,
  faDisplay,
  faFolderTree,
  faCheck,
  faTag,
  faTags,
  faClone,
  faNoteSticky,
  faWarehouse,
  faTriangleExclamation,
  faEye,
  faEyeSlash,
  faUpRightFromSquare,
  faEuroSign,
  faSpinner,
  faClock,
  faLayerGroup,
  faMinus,
  faRecycle,
  faSnowflake,
  faBezierCurve,
  faSliders,
  faSoap,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCode,
  faRemove,
  faSearch,
  faFlaskVial,
  faPrescriptionBottle,
  faCircleInfo,
  faTablets,
  faWineBottle,
  faCubesStacked,
  faGear,
  faSitemap,
  faAngleDown,
  faAngleUp,
  faAnglesDown,
  faAnglesUp,
  faCalendar,
  faCalendarCheck,
  faUserGear,
  faUser,
  faBars,
  faXmark,
  faArrowLeft,
  faBook,
  faPrint,
  faTentArrowDownToLine,
  faCalendarDay,
  faEyeDropper,
  faTimeline,
  faPen,
  faFileExcel,
  faFileArrowDown,
  faBreadSlice,
  faBox,
  faPlus,
  faCircle,
  faFilter,
  faFilterCircleXmark,
  faDroplet,
  faAnglesRight,
  faCalendarPlus,
  faLink,
  faSort,
  faSortUp,
  faSortDown,
  faGroupArrowsRotate,
  faQrcode,
  faDisplay,
  faFolderTree,
  faCheck,
  faTag,
  faTags,
  faClone,
  faWarehouse,
  faNoteSticky,
  faTriangleExclamation,
  faEye,
  faEyeSlash,
  faUpRightFromSquare,
  faEuroSign,
  faSpinner,
  faClock,
  faLayerGroup,
  faMinus,
  faRecycle,
  faSnowflake,
  faBezierCurve,
  faSliders,
  faSoap,
);
